import React from 'react';
import style from '../Content.module.css';
import s from './Projects.module.css';

export const Project = (props) => {

  const {repositories, refRepositories,
        refDeploy, dataOnLogin, gif,
        purposeProject, readyFunctionally,
        usedTechnologies, imgProjectRef,
        projectName, refName, isFrame
        } = props;

  const readyMountFunctionally = readyFunctionally ? readyFunctionally.map(func => <li>{func}</li>) : null;

  return (
    <>
      <div className={style.infoBlocks}>
        <div className={style.nameBlock}>{projectName}</div>
        <img src={imgProjectRef} className={style.img}/>
      </div>

      <div className={`${style.content} ${s.marginBlock}`}>

        {repositories ? (
          <div>
            <span className={s.title}>Репозиторий:</span>
            <a href={refRepositories} className={s.title} target='_blank'> {repositories}</a>
          </div>) : null}

      <br/>
      <div>
        <span className={s.title}>Перейти на сайт: <a href={refDeploy} target="_blank">{refName}</a></span>
      </div>

        {isFrame ? (

          <div className={s.frame}>
            <br/>
            <iframe src={isFrame} width="610" height="460" align="left" frameBorder="0"> </iframe>
        </div>) : null}

      <br/>
      <div>
        {dataOnLogin ? (
          <span className={s.title}>Данные для тестового входа:
              <ul className={s.dataLogin}>
                  <li><span>Логин: </span>{dataOnLogin[0]}</li>
                  <li><span>Пароль: </span>{dataOnLogin[1]}</li>
              </ul>
          </span>)
          : null}
      </div>
      <br/>

        {gif ? (
          <div>
          <a href={refDeploy} target="_blank"><img src={gif} className={s.animationExcel}/></a>
        </div>) : null}



      <div className={s.projectDescription}>
        <h3>
          Цель проекта:
        </h3>

          {purposeProject}

        {readyMountFunctionally ? (
          <>
              <h3>
                Реализованный функционал:
              </h3>
              <ul>
                {readyMountFunctionally}
              </ul>
            </>
        ) : null}

        <br/>
        <h3 className={s.h3}>Используются:</h3>
        <span className={s.title}> {usedTechnologies}</span>
      </div>


    </div>
    </>
  )
}